import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagingService } from 'app/modules/shared/services/messaging.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import { environment } from 'environments/environment';
import { Subscription } from 'rxjs';
import { CommonBindingDataService } from '../../modules/shared/services/common-binding-data.service';
import { ErrorBindingService } from '../../modules/shared/services/error-binding.service';
import { AppSettings } from './../../modules/shared/app.settings';
import { NotificationsService } from './../../modules/shared/services/notifications.service';
import { StorageService } from './../../modules/shared/services/storage.service';
import { UserCommonService } from './../../modules/shared/services/user-common.service';
import { GlobalConfigService } from 'app/modules/global-config/services/global-config.service';
// import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-sign-in-layout',
  templateUrl: './sign-in-layout.component.html'
})

export class SignInLayoutComponent implements OnInit {
  signInResponse: any;
  // message: Message[] = [];
  otpId;
  forgotPopup = false;
  loginErrors = [{
    email: false,
    password: false,
  }];
  subscription: Subscription;
  otpPopup = false;
  setPasswordPopup = false;
  isMetadataLoaded = false;
  otpEmail;
  otpPhone;
  data;

  signInWelcomeTextLabel;
  signInDescription;
  readMoreLabel;
  labelResetPassword;
  labelValidateOtp;
  isCompanyRole = false;
  message1;
  deviceInfo = null;
  notification_token;
  device_details;
  reportDownloadUrl: any;
  signInVersion = environment.signInVersion;
  constructor(
    private userCommonService: UserCommonService,
    private router: Router,
    private storageService: StorageService,
    private commonBindingDataService: CommonBindingDataService,
    private notificationService: NotificationsService,
    private errorBindingService: ErrorBindingService,
    private uiService: UiService,
    private messagingService: MessagingService,
    private route: ActivatedRoute,
    private globalConfigService: GlobalConfigService,
    // private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {
    this.messagingService.requestPermission();
    // this.messagingService.receiveMessage();
    // this.message1 = this.messagingService.currentMessage;

    this.signInWelcomeTextLabel = this.commonBindingDataService.getLabel('label_sign_in_welcome_text');
    this.signInDescription = this.commonBindingDataService.getLabel('label_sign_in_description');
    this.readMoreLabel = this.commonBindingDataService.getLabel('label_read_more');
    this.labelResetPassword = this.commonBindingDataService.getLabel('label_reset_password');
    this.labelValidateOtp = this.commonBindingDataService.getLabel('label_validate_otp');
    const isIntervalCheck = this.storageService.getItemLocalStorage(AppSettings.INTERVAL);
    this.reportDownloadUrl = localStorage.getItem('returnUrl');
  }

  doSignIn(signInData) {
    this.signInApiCall(signInData);

  }

  signInApiCall(signInData) {
    this.storageService.removeAllCookies();

    // web push notification :: notification token :: start
    this.notification_token = this.storageService.getItem('notificationToken');
    // console.log(this.notification_token);
    const ba = ['Chrome', 'Firefox', 'Safari', 'Opera', 'MSIE', 'Trident', 'Edge'];
    let b;
    const ua = navigator.userAgent;
    for (let i = 0; i < ba.length; i++) {
      if (ua.indexOf(ba[i]) > -1) {
        b = ba[i];
        break;
      }
    }
    if (b === 'MSIE' || b === 'Trident' || b === 'Edge') {
      b = 'Internet Explorer';
    }

    const temp = {
      deviceName: b,
      deviceType: 'web',
      os: navigator.platform,
      // appVersion : '1',
      // osVersion : '18',
      notificationToken: this.notification_token,
      // deviceId : 'AA2C210D-E050-4E5C-8CEC-424F3DAA9CF9Web'
    };
    this.device_details = temp;
    signInData.deviceDetails = this.device_details;
    // web push notification :: notification token :: end

    this.userCommonService.signIn(JSON.stringify(signInData)).subscribe(signInResult => {
      if (signInResult) {
        if (!this.userCommonService.isUserActivated(signInResult)) {
          this.storageService.removeAllCookies();
          this.storageService.removeAll();
          this.uiService.showMessage(
            'Your account has been deactivated. Please contact your administrator.',
            AppSettings.MESSAGE_TYPES.ERROR
          );
          return;
        }
        this.signInResponse = signInResult;
        sessionStorage.setItem('userRoleId', signInResult.user.roleId);
        sessionStorage.setItem('providerId', signInResult.user.id);
        sessionStorage.setItem('username', signInResult.user.username);
        if (this.signInResponse.accessGroup !== null && this.signInResponse.accessGroup.length > 0) {
          this.notificationService.canFetchNotification = true;
          this.setSessionAndUserDetails(signInResult);
          this.userCommonService.getUserMasterMetaData();
          this.userCommonService.getAdminUserMetaData();
          this.userCommonService.setRolesAndGenerateSidebar();
          this.userCommonService.getDispatchListFilter();
          this.storageService.setItem('idleTime', AppSettings.IDLE_TIME);
          this.storageService.setItemInCookies('sessionToken', signInResult.sessionToken);
          localStorage.setItem('saveAppointmentDraft', signInResult.saveAppointmentDraft);
          this.reportDownloadUrl = localStorage.getItem('returnUrl');
          localStorage.removeItem('returnUrl');
          // Cold start used to store the providers list as returnUrl. Ignore that default
          // so sign-in lands on Dispatch Requests.
          const isProvidersListReturnUrl = this.isProvidersListUrl(this.reportDownloadUrl);
          if (this.reportDownloadUrl && !isProvidersListReturnUrl) {
            this.router.navigateByUrl(this.reportDownloadUrl)
              .then(navigated => {
                if (!navigated) {
                  this.navigateToDefaultPage();
                }
              })
              .catch(() => this.navigateToDefaultPage());
          } else {
            this.navigateToDefaultPage();
          }
        } else {
          this.uiService.showMessage(this.commonBindingDataService.getLabel('error_invalid_access_group'), AppSettings.MESSAGE_TYPES.ERROR);
        }
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  navigateToDefaultPage() {
    this.router.navigate(['/dispatch-request/dispatch-request-listview']);
  }

  setSessionAndUserDetails(results) {
    this.storageService.setItem(AppSettings.USER_DETAILS, results.user);
    this.storageService.setItem(AppSettings.ACCESS_MENU, this.signInResponse.accessGroup);
    this.storageService.setItem('internalCheckListPermissions', results.internalCheckListPermissions);
    this.storageService.setItem('sdohScreeningPermissions', results.sdohScreeningPermissions);
    this.storageService.setItem('headerAccessPermissionDispatch', results.addDispatch);
    AppSettings.USER = results.user;
    this.setTagList();
    this.getGlobalConfigurations();
    if (results.user.userDetails !== null) {
      this.storageService.setItem(AppSettings.CURRENT_USER_CORPORATE_ID, results.user.userDetails.corporateId);
    }
  }

  getGlobalConfigurations() {
    this.globalConfigService.getGlobalConfigList().subscribe((res) => {
      if (res && res.shiftConfigurations && res.shiftConfigurations.length > 0
        && res.dutyMasterConfigurations && res.dutyMasterConfigurations.length > 0) {
        const globalConfig = [...res.shiftConfigurations, ...res.dutyMasterConfigurations];
        localStorage.setItem(AppSettings.GLOBAL_CONFIG, JSON.stringify(globalConfig));
      }
    }, (err) => {
    });
  }

  setTagList() {
    this.userCommonService.getTagsListApi().subscribe(result => {
      this.storageService.setItem(AppSettings.TAG_DATA, result);
      localStorage.setItem('localTagdata', JSON.stringify(result));
    }, (error) => {
    });
  }

  moduleWiseRouteAccesses() {
    const groups = {};
    let accesses = this.signInResponse.accesses;
    for (let i = 0; i < accesses.length; i++) {
      const accessGroupName = accesses[i].accessGroupName;
      if (!groups[accessGroupName]) {
        groups[accessGroupName] = [];
      }
      groups[accessGroupName].push(accesses[i].accessName);
    }
    accesses = [];
    for (const accessGroupName in groups) {
      if (groups.hasOwnProperty(accessGroupName)) {
        accesses.push({ group: accessGroupName, accessName: groups[accessGroupName] });
      }
    }
    this.storageService.setItem(AppSettings.ACCESS_LIST, accesses);
  }

  uniqArray(arrArg) {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) === pos;
    });
  }

  forgotPassword() {
    this.router.navigate(['/forgot-password']);
  }

  onPopClose(event) {
    this.forgotPopup = false;
  }

  onOtpPopClose(event) {
    this.otpPopup = false;
  }

  onSetPasswordPopClose(event) {
    this.setPasswordPopup = false;
  }

  onOtpPopSave(event) {
    if (event.general !== undefined) {
      this.uiService.showMessage(event.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    } else {
      if (event.otpId) {
        this.otpId = event.otpId;
        this.uiService.showMessage(this.commonBindingDataService.getLabel('matched_otp'), AppSettings.MESSAGE_TYPES.SUCCESS);
        this.setPasswordPopup = true;
      }
    }
    this.forgotPopup = false;
    this.otpPopup = false;
  }

  onPopSave(results) {
    this.otpEmail = results;
    this.otpPhone = results.phone;
    this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
    this.forgotPopup = false;
    this.otpPopup = true;
  }

  private isProvidersListUrl(url: string): boolean {
    if (!url) {
      return false;
    }
    const path = url.split('?')[0].replace(/\/$/, '');
    return path === '/hc-providers' || path === 'hc-providers';
  }

}
